import React from 'react';
import styled from '@emotion/styled';

import { getItemPriceString, getProductImageUrl } from '../../helpers';

const Wrapper = styled('div')`
  position: relative;
  margin-top: 25px;
  .card {
    &.not-available {
      opacity: 0.4;
    }
  }
  .card-img-top {
    background-color: #f2f3f4;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    min-height: 150px;
  }
`;

const CardView = (props) => {
  const { data, currencySymbol, onItemClick } = props;

  return (
    <Wrapper className="row">
      {/* <SpinnerBlock show={loading} /> */}
      {data.map((item) => (
        <div
          className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
          key={item.id}
          onClick={() => onItemClick(item)}
        >
          <div className={`card ${!item.available ? 'not-available' : ''}`}>
            <div
              className="card-img-top"
              style={{ backgroundImage: `url(${getProductImageUrl(item, 250)})` }}
            />
            {/* <img className="card-img-top img-fluid" src={item.images && item.images.length ? item.images[0].url : mockImg} alt={item.shortName} /> */}
            <div className="card-body">
              <h5 className="card-title">{item.shortName}</h5>
              <p className="card-text">{getItemPriceString(item, null, currencySymbol)}</p>
            </div>
          </div>
        </div>
      ))}
    </Wrapper>
  );
};

export default CardView;
